/** Current pipeline step — same keys as `list_status` on the API. */
export const CANDIDATE_STATUS_BADGE = {
  shortlisted_ai_interview: { label: 'Shortlisted for AI interview', cls: 'badge-blue' },
  pending_interview: { label: 'Pending interview', cls: 'badge-yellow' },
  interview_in_progress: { label: 'Interview in progress', cls: 'badge-blue' },
  ai_interview_done: { label: 'AI interview done', cls: 'badge-blue' },
  shortlisted_second_round: { label: 'Shortlisted for second round', cls: 'badge-blue' },
  pending_second_round: { label: 'Pending second round', cls: 'badge-yellow' },
  second_round_done: { label: 'Second round done', cls: 'badge-blue' },
  shortlisted: { label: 'Selected', cls: 'badge-green' },
  selected: { label: 'Selected', cls: 'badge-green' },
  on_hold: { label: 'On hold', cls: 'badge-yellow' },
  rejected: { label: 'Rejected', cls: 'badge-red' },
  rejected_resume: { label: 'Rejected at resume', cls: 'badge-red' },
  rejected_interview: { label: 'Rejected at AI interview', cls: 'badge-red' },
  rejected_final: { label: 'Rejected in final round', cls: 'badge-red' },
  archived: { label: 'Archived', cls: 'badge-gray' },
  deleted: { label: 'Deleted', cls: 'badge-red' },
  in_review: { label: 'In review', cls: 'badge-gray' },
};

export function candidateStatusBadge(status) {
  return CANDIDATE_STATUS_BADGE[status] || CANDIDATE_STATUS_BADGE.in_review;
}

/** Prefer Selected / On hold / specific reject, else the current pipeline step. */
export function listCandidateStatusKey(c) {
  const step = c?.status || 'in_review';
  if (String(step).startsWith('rejected')) return step;
  if (c?.shortlist_status === 'selected') return 'selected';
  if (c?.shortlist_status === 'on_hold') return 'on_hold';
  return step;
}
